import { Link } from "react-router-dom";
import {
  CalendarDays,
  Clock3,
  ExternalLink,
  Mail,
  MapPin,
  Phone,
} from "lucide-react";

import { PetCard } from "../../../../components/ui/PetCard";
import {
  formatCellPhoneNumber,
  formatCpf,
} from "../../../../services/functions";
import { displayValue, formatAddress, formatDate } from "./helpers";

export function CustomerDetailsSummary({ customer, onNavigate }) {
  const phone = customer.cellphone || customer.telephone;
  const customerAttributes = [
    { label: "Nome", value: displayValue(customer.name) },
    { label: "TutorCpf", value: displayValue(formatCpf(customer.cpf)) },
  ];

  return (
    <PetCard.Root
      data-full
      noAction
      size="small"
      style={{ maxWidth: "100%", minWidth: "100%" }}
    >
      <div className="flex w-full flex-wrap items-start justify-between gap-4">
        <div className="flex min-w-0 flex-1 items-center gap-4">
          <PetCard.Avatar attributes={customerAttributes} className="!w-14 !h-14 [&_span]:!text-[25px]" />
          <div className="min-w-0 flex-1">
            <PetCard.Attributes
              attributes={customerAttributes}
              noIcon
              show={["Nome"]}
            />
            <div className="mt-2">
              <PetCard.Attribute label="TutorCpf">
                {displayValue(formatCpf(customer.cpf))}
              </PetCard.Attribute>
            </div>
          </div>
        </div>

        {customer.id && (
          <Link
            className="inline-flex items-center gap-2 rounded-md border border-scale-500 px-3 py-2 text-sm font-semibold text-scale-700 transition-colors hover:bg-scale-50 focus:outline-none focus:ring-2 focus:ring-scale-400"
            onClick={onNavigate}
            to={`/clientes/resumo/${customer.id}`}
          >
            Ver perfil completo
            <ExternalLink aria-hidden="true" size={16} />
          </Link>
        )}
      </div>

      <div className="grid w-full grid-cols-2 gap-y-2 border-t border-gray-100 pt-4 ">
        <span className="mb-1 flex items-center gap-2 text-sm font-medium text-gray-800">
          <Phone aria-hidden="true" size={15} />
          {displayValue(formatCellPhoneNumber(phone))}
        </span>
        <span className="mb-1 flex items-center gap-2 text-sm font-medium text-gray-800">
          <Mail aria-hidden="true" size={15} />
          {displayValue(customer.email)}
        </span>
        <span className="mb-1 flex items-center gap-2 text-sm font-medium text-gray-800">
          <CalendarDays aria-hidden="true" size={15} />
          {formatDate(customer.createdAt)}
        </span>
        <span className="mb-1 flex items-center gap-2 text-sm font-medium text-gray-800">
          <Clock3 aria-hidden="true" size={15} />
          {formatDate(customer.lastVisitAt, true)}
        </span>
        <span className="mb-1 flex items-center gap-2 col-span-2 text-sm font-medium text-gray-800">
          <MapPin aria-hidden="true" size={15} />
          {formatAddress(customer.address)}
        </span>
      </div>
    </PetCard.Root>
  );
}
